/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AuthSocialCallbackRequest,
  AuthSocialInitiateParams,
  ChangePasswordRequest,
  EmailVerificationConfirmRequest,
  EmailVerificationResendRequest,
  ErrorResponse,
  LoginRequest,
  LogoutRequest,
  PasswordResetConfirmRequest,
  PasswordResetRequestRequest,
  UserCreateRequest,
  UserDetail,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 현재 비밀번호를 확인한 후 새 비밀번호로 변경합니다.
 * @summary 비밀번호 변경
 */
export const authChangePassword = (
  changePasswordRequest: BodyType<ChangePasswordRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/auth/change-password/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: changePasswordRequest,
      signal,
    },
    options,
  );
};

export const getAuthChangePasswordMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authChangePassword>>,
    TError,
    { data: BodyType<ChangePasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authChangePassword>>,
  TError,
  { data: BodyType<ChangePasswordRequest> },
  TContext
> => {
  const mutationKey = ["authChangePassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authChangePassword>>,
    { data: BodyType<ChangePasswordRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return authChangePassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof authChangePassword>>
>;
export type AuthChangePasswordMutationBody = BodyType<ChangePasswordRequest>;
export type AuthChangePasswordMutationError = ErrorType<
  ErrorResponse | ErrorResponse
>;

/**
 * @summary 비밀번호 변경
 */
export const useAuthChangePassword = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authChangePassword>>,
      TError,
      { data: BodyType<ChangePasswordRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authChangePassword>>,
  TError,
  { data: BodyType<ChangePasswordRequest> },
  TContext
> => {
  const mutationOptions = getAuthChangePasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 이메일과 비밀번호로 로그인하여 JWT 토큰을 발급받습니다.
 * @summary 로그인
 */
export const authLogin = (
  loginRequest: BodyType<LoginRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/auth/login/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: loginRequest,
      signal,
    },
    options,
  );
};

export const getAuthLoginMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authLogin>>,
    TError,
    { data: BodyType<LoginRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authLogin>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  const mutationKey = ["authLogin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authLogin>>,
    { data: BodyType<LoginRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return authLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof authLogin>>
>;
export type AuthLoginMutationBody = BodyType<LoginRequest>;
export type AuthLoginMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 로그인
 */
export const useAuthLogin = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authLogin>>,
      TError,
      { data: BodyType<LoginRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authLogin>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  const mutationOptions = getAuthLoginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 리프레시 토큰을 블랙리스트에 추가하여 로그아웃합니다.
 * @summary 로그아웃
 */
export const authLogout = (
  logoutRequest: BodyType<LogoutRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/auth/logout/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: logoutRequest,
      signal,
    },
    options,
  );
};

export const getAuthLogoutMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authLogout>>,
    TError,
    { data: BodyType<LogoutRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authLogout>>,
  TError,
  { data: BodyType<LogoutRequest> },
  TContext
> => {
  const mutationKey = ["authLogout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authLogout>>,
    { data: BodyType<LogoutRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return authLogout(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthLogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof authLogout>>
>;
export type AuthLogoutMutationBody = BodyType<LogoutRequest>;
export type AuthLogoutMutationError = ErrorType<ErrorResponse | ErrorResponse>;

/**
 * @summary 로그아웃
 */
export const useAuthLogout = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authLogout>>,
      TError,
      { data: BodyType<LogoutRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authLogout>>,
  TError,
  { data: BodyType<LogoutRequest> },
  TContext
> => {
  const mutationOptions = getAuthLogoutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * provider OAuth code를 교환하고 JWT를 발급합니다. 기존 사용자 매칭 우선, 신규 시 acceptTerms/acceptPrivacy 둘 다 true 필요 (한국 개인정보보호법).
 * @summary 소셜 로그인 콜백
 */
export const authSocialCallback = (
  provider: string,
  authSocialCallbackRequest: BodyType<AuthSocialCallbackRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/auth/oauth/${provider}/callback/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: authSocialCallbackRequest,
      signal,
    },
    options,
  );
};

export const getAuthSocialCallbackMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authSocialCallback>>,
    TError,
    { provider: string; data: BodyType<AuthSocialCallbackRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authSocialCallback>>,
  TError,
  { provider: string; data: BodyType<AuthSocialCallbackRequest> },
  TContext
> => {
  const mutationKey = ["authSocialCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authSocialCallback>>,
    { provider: string; data: BodyType<AuthSocialCallbackRequest> }
  > = (props) => {
    const { provider, data } = props ?? {};

    return authSocialCallback(provider, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthSocialCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof authSocialCallback>>
>;
export type AuthSocialCallbackMutationBody =
  BodyType<AuthSocialCallbackRequest>;
export type AuthSocialCallbackMutationError = ErrorType<
  ErrorResponse | ErrorResponse | ErrorResponse
>;

/**
 * @summary 소셜 로그인 콜백
 */
export const useAuthSocialCallback = <
  TError = ErrorType<ErrorResponse | ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authSocialCallback>>,
      TError,
      { provider: string; data: BodyType<AuthSocialCallbackRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authSocialCallback>>,
  TError,
  { provider: string; data: BodyType<AuthSocialCallbackRequest> },
  TContext
> => {
  const mutationOptions = getAuthSocialCallbackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * provider별 OAuth 인증 URL을 반환합니다.
 * @summary 소셜 로그인 시작
 */
export const authSocialInitiate = (
  provider: string,
  params?: AuthSocialInitiateParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/auth/oauth/${provider}/initiate/`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getAuthSocialInitiateQueryKey = (
  provider?: string,
  params?: AuthSocialInitiateParams,
) => {
  return [
    `/api/auth/oauth/${provider}/initiate/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAuthSocialInitiateQueryOptions = <
  TData = Awaited<ReturnType<typeof authSocialInitiate>>,
  TError = ErrorType<ErrorResponse | ErrorResponse>,
>(
  provider: string,
  params?: AuthSocialInitiateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSocialInitiate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAuthSocialInitiateQueryKey(provider, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof authSocialInitiate>>
  > = ({ signal }) =>
    authSocialInitiate(provider, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!provider,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof authSocialInitiate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthSocialInitiateQueryResult = NonNullable<
  Awaited<ReturnType<typeof authSocialInitiate>>
>;
export type AuthSocialInitiateQueryError = ErrorType<
  ErrorResponse | ErrorResponse
>;

export function useAuthSocialInitiate<
  TData = Awaited<ReturnType<typeof authSocialInitiate>>,
  TError = ErrorType<ErrorResponse | ErrorResponse>,
>(
  provider: string,
  params: undefined | AuthSocialInitiateParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSocialInitiate>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authSocialInitiate>>,
          TError,
          Awaited<ReturnType<typeof authSocialInitiate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthSocialInitiate<
  TData = Awaited<ReturnType<typeof authSocialInitiate>>,
  TError = ErrorType<ErrorResponse | ErrorResponse>,
>(
  provider: string,
  params?: AuthSocialInitiateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSocialInitiate>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authSocialInitiate>>,
          TError,
          Awaited<ReturnType<typeof authSocialInitiate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthSocialInitiate<
  TData = Awaited<ReturnType<typeof authSocialInitiate>>,
  TError = ErrorType<ErrorResponse | ErrorResponse>,
>(
  provider: string,
  params?: AuthSocialInitiateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSocialInitiate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 소셜 로그인 시작
 */

export function useAuthSocialInitiate<
  TData = Awaited<ReturnType<typeof authSocialInitiate>>,
  TError = ErrorType<ErrorResponse | ErrorResponse>,
>(
  provider: string,
  params?: AuthSocialInitiateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof authSocialInitiate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAuthSocialInitiateQueryOptions(
    provider,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 이메일 링크의 토큰과 새 비밀번호로 변경합니다.
 * @summary 비밀번호 재설정 확인
 */
export const authPasswordResetConfirm = (
  passwordResetConfirmRequest: BodyType<PasswordResetConfirmRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/auth/password-reset/confirm/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: passwordResetConfirmRequest,
      signal,
    },
    options,
  );
};

export const getAuthPasswordResetConfirmMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authPasswordResetConfirm>>,
    TError,
    { data: BodyType<PasswordResetConfirmRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authPasswordResetConfirm>>,
  TError,
  { data: BodyType<PasswordResetConfirmRequest> },
  TContext
> => {
  const mutationKey = ["authPasswordResetConfirm"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authPasswordResetConfirm>>,
    { data: BodyType<PasswordResetConfirmRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return authPasswordResetConfirm(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthPasswordResetConfirmMutationResult = NonNullable<
  Awaited<ReturnType<typeof authPasswordResetConfirm>>
>;
export type AuthPasswordResetConfirmMutationBody =
  BodyType<PasswordResetConfirmRequest>;
export type AuthPasswordResetConfirmMutationError = ErrorType<
  ErrorResponse | ErrorResponse
>;

/**
 * @summary 비밀번호 재설정 확인
 */
export const useAuthPasswordResetConfirm = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authPasswordResetConfirm>>,
      TError,
      { data: BodyType<PasswordResetConfirmRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authPasswordResetConfirm>>,
  TError,
  { data: BodyType<PasswordResetConfirmRequest> },
  TContext
> => {
  const mutationOptions = getAuthPasswordResetConfirmMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 입력한 이메일로 재설정 링크를 보냅니다. 보안을 위해 가입 여부와 무관하게 항상 200을 반환합니다.
 * @summary 비밀번호 재설정 메일 발송 요청
 */
export const authPasswordResetRequest = (
  passwordResetRequestRequest: BodyType<PasswordResetRequestRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/auth/password-reset/request/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: passwordResetRequestRequest,
      signal,
    },
    options,
  );
};

export const getAuthPasswordResetRequestMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authPasswordResetRequest>>,
    TError,
    { data: BodyType<PasswordResetRequestRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authPasswordResetRequest>>,
  TError,
  { data: BodyType<PasswordResetRequestRequest> },
  TContext
> => {
  const mutationKey = ["authPasswordResetRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authPasswordResetRequest>>,
    { data: BodyType<PasswordResetRequestRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return authPasswordResetRequest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthPasswordResetRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof authPasswordResetRequest>>
>;
export type AuthPasswordResetRequestMutationBody =
  BodyType<PasswordResetRequestRequest>;
export type AuthPasswordResetRequestMutationError = ErrorType<
  ErrorResponse | ErrorResponse
>;

/**
 * @summary 비밀번호 재설정 메일 발송 요청
 */
export const useAuthPasswordResetRequest = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authPasswordResetRequest>>,
      TError,
      { data: BodyType<PasswordResetRequestRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authPasswordResetRequest>>,
  TError,
  { data: BodyType<PasswordResetRequestRequest> },
  TContext
> => {
  const mutationOptions = getAuthPasswordResetRequestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 새 사용자 계정을 생성하고 JWT 토큰을 반환합니다.
 * @summary 회원가입
 */
export const authRegister = (
  userCreateRequest: BodyType<UserCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<UserDetail>(
    {
      url: `/api/auth/register/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: userCreateRequest,
      signal,
    },
    options,
  );
};

export const getAuthRegisterMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authRegister>>,
    TError,
    { data: BodyType<UserCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authRegister>>,
  TError,
  { data: BodyType<UserCreateRequest> },
  TContext
> => {
  const mutationKey = ["authRegister"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authRegister>>,
    { data: BodyType<UserCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return authRegister(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthRegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof authRegister>>
>;
export type AuthRegisterMutationBody = BodyType<UserCreateRequest>;
export type AuthRegisterMutationError = ErrorType<
  ErrorResponse | ErrorResponse
>;

/**
 * @summary 회원가입
 */
export const useAuthRegister = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authRegister>>,
      TError,
      { data: BodyType<UserCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authRegister>>,
  TError,
  { data: BodyType<UserCreateRequest> },
  TContext
> => {
  const mutationOptions = getAuthRegisterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 이메일 링크의 토큰으로 이메일 인증을 완료합니다.
 * @summary 이메일 인증 확인
 */
export const authEmailVerifyConfirm = (
  emailVerificationConfirmRequest: BodyType<EmailVerificationConfirmRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/auth/verify-email/confirm/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: emailVerificationConfirmRequest,
      signal,
    },
    options,
  );
};

export const getAuthEmailVerifyConfirmMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authEmailVerifyConfirm>>,
    TError,
    { data: BodyType<EmailVerificationConfirmRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authEmailVerifyConfirm>>,
  TError,
  { data: BodyType<EmailVerificationConfirmRequest> },
  TContext
> => {
  const mutationKey = ["authEmailVerifyConfirm"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authEmailVerifyConfirm>>,
    { data: BodyType<EmailVerificationConfirmRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return authEmailVerifyConfirm(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthEmailVerifyConfirmMutationResult = NonNullable<
  Awaited<ReturnType<typeof authEmailVerifyConfirm>>
>;
export type AuthEmailVerifyConfirmMutationBody =
  BodyType<EmailVerificationConfirmRequest>;
export type AuthEmailVerifyConfirmMutationError = ErrorType<
  ErrorResponse | ErrorResponse
>;

/**
 * @summary 이메일 인증 확인
 */
export const useAuthEmailVerifyConfirm = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authEmailVerifyConfirm>>,
      TError,
      { data: BodyType<EmailVerificationConfirmRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authEmailVerifyConfirm>>,
  TError,
  { data: BodyType<EmailVerificationConfirmRequest> },
  TContext
> => {
  const mutationOptions = getAuthEmailVerifyConfirmMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 입력한 이메일이 가입되어 있고 미인증 상태면 인증 메일을 재발송합니다. enumeration 방지를 위해 항상 200을 반환합니다.
 * @summary 이메일 인증 메일 재발송
 */
export const authEmailVerifyResend = (
  emailVerificationResendRequest: BodyType<EmailVerificationResendRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/auth/verify-email/resend/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: emailVerificationResendRequest,
      signal,
    },
    options,
  );
};

export const getAuthEmailVerifyResendMutationOptions = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authEmailVerifyResend>>,
    TError,
    { data: BodyType<EmailVerificationResendRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authEmailVerifyResend>>,
  TError,
  { data: BodyType<EmailVerificationResendRequest> },
  TContext
> => {
  const mutationKey = ["authEmailVerifyResend"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authEmailVerifyResend>>,
    { data: BodyType<EmailVerificationResendRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return authEmailVerifyResend(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthEmailVerifyResendMutationResult = NonNullable<
  Awaited<ReturnType<typeof authEmailVerifyResend>>
>;
export type AuthEmailVerifyResendMutationBody =
  BodyType<EmailVerificationResendRequest>;
export type AuthEmailVerifyResendMutationError = ErrorType<
  ErrorResponse | ErrorResponse
>;

/**
 * @summary 이메일 인증 메일 재발송
 */
export const useAuthEmailVerifyResend = <
  TError = ErrorType<ErrorResponse | ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof authEmailVerifyResend>>,
      TError,
      { data: BodyType<EmailVerificationResendRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof authEmailVerifyResend>>,
  TError,
  { data: BodyType<EmailVerificationResendRequest> },
  TContext
> => {
  const mutationOptions = getAuthEmailVerifyResendMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
